import { createContext as reactCreateContext, useContext } from 'react';
import { useLocation } from 'react-router-dom';
import { WorksSearchParameters } from './api';

export const createContext = <T>(): [React.Context<T>, () => T] => {
  const ctx = reactCreateContext<T | undefined>(undefined);
  const use = () => {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const value = useContext(ctx);
    return value;
  };

  return [ctx as React.Context<T>, use as () => T];
};

export const toIntArray = (a: string[]): number[] => {
  const ret: number[] = [];
  a.forEach((s) => {
    const n = parseInt(s, 10);
    if (!Number.isNaN(n)) {
      ret.push(n);
    }
  });
  return ret;
};

export const useInitialSearchParameters = (): WorksSearchParameters => {
  const location = useLocation();
  const parameters = new URLSearchParams(location.search.slice(1));
  const limit = parseInt(parameters.get('limit') ?? '10', 10);
  return {
    page: 1,
    limit: Number.isNaN(limit) ? 10 : limit,
    plan: 0,
    industry: toIntArray(parameters.getAll('industry')),
    taste: toIntArray(parameters.getAll('taste')),
    option: toIntArray(parameters.getAll('option')),
  };
};

export const toQueryString = (p: WorksSearchParameters): string => {
  const params = Object.entries(p).reduce<URLSearchParams>((prev, [k, v]) => {
    if (k === 'plan') {
      return prev;
    }
    if (Array.isArray(v)) {
      v.forEach((n) => {
        prev.append(`${k}`, n.toString());
      });
    } else {
      prev.set(k, v.toString());
    }
    return prev;
  }, new URLSearchParams());

  return params.toString();
};

export const isMobile = (): boolean => !!navigator.userAgent.match(/iPhone|Android.+Mobile/);
